import ButtonSolid from "./ButtonSolid";
import ButtonOutline from "./ButtonOutline";
const Button = {
  Solid: ButtonSolid,
  Outline: ButtonOutline,
};

export default Button;
